<div class="d-grid mx-auto">
  <div class="col-md-auto">
    <p class="text-center">
      Thank you for supporting local farms and our most food-insecure neighbors
    </p>
  </div>
</div>

<div class="donation-container">
  <!-- Predefined amounts -->
  <div class="predefined-amounts">
    @for (amount of predefinedAmounts; track amount) {
      <button 
        type="button" 
        class="btn btn-outline-primary amount-btn"
        (click)="selectPredefinedAmount(amount)">
        ${{ amount }}
      </button>
    }
  </div>

  <!-- Custom amount input -->
  <div class="custom-amount mt-4">
    <input 
      type="text" 
      class="form-control form-control-lg" 
      placeholder="$0.00"
      [(ngModel)]="displayAmount"
      (input)="onAmountInput($event)">
  </div>
</div>

<div class="modal-action-row has-btn-2 mt-4">
  <button 
    type="button" 
    class="btn btn-outline-primary" 
    (click)="closeModal()"
    [disabled]="isLoading()">
    Cancel
  </button>
  <button 
    type="button" 
    class="btn btn-primary" 
    (click)="donate()"
    [disabled]="isLoading()">
    @if (isLoading()) {
      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      Processing...
    } @else {
      Donate
    }
  </button>
</div>

